module.exports = __webpack_public_path__ + "img/anf1.06cefcdc.png";